import { Button, Flex, Link, Text } from 'rebass';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../../../styles/theme';
import { LogoSvg } from './Logo';
import { OPTIONS_ANIMATION_DURATION } from './constants';
import { isMobile } from 'react-device-detect';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const Option = styled(Flex)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

const CheckboxWrap = styled(Flex)`
  border-color: rgba(0, 0, 0, 0.19);
  border-width: 2px;
  border-radius: 9px;
  border-style: solid;
  transition: all var(0.3s) linear;
  overflow: hidden;
  height: 20px;
  width: 20px;
`;

export const SexAtBirth = ({ title, state, id, onChange, onContinue }) => {
  return (
    <Flex flex={1} flexDirection={'column'}>
      <LogoSvg />
      <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} mb={3}>
        What was your sex assigned at birth?
      </Text>
      <Text fontWeight={300} fontSize={'16px'} color="#747373" mt={4}>
        Biological sex is important for making medical decisions.
      </Text>
      <Flex my={3} flexDirection={'column'}>
        {[{ label: 'Female', value: 'F' }, { label: 'Male', value: 'M' }].map((x, i) => {
          const isSelected = (state || {})['assignedsexatbirth'] === x.value;
          return (
            <Option
              key={x.value}
              style={{
                animationDelay: `${1 + i * OPTIONS_ANIMATION_DURATION}s`,
              }}
            >
              <Flex flexDirection={'column'} flex={1}>
                <Flex
                  mb={3}
                  style={{
                    cursor: 'pointer',
                    overflow: 'hidden',
                    width: '100%',
                    borderRadius: '12px',
                    border: `${isSelected ? '2px solid rgb(249, 163, 148)' : '1px solid rgba(0, 0, 0, 0.15)'}`,
                    padding: isMobile ? (isSelected ? '14px 18px' : '15px 19px') : isSelected ? '18px' : '19px',
                    backgroundColor: isSelected ? 'rgba(255,255,255,0.43)' : 'transparent',
                    flex: 1,
                  }}
                  onClick={() => {
                    onChange('assignedsexatbirth', isSelected ? null : x.value);
                  }}
                >
                  <CheckboxWrap style={{ borderColor: isSelected ? theme.color.pink : '', alignSelf: 'baseline' }}>
                    <Flex
                      flex={1}
                      style={{ background: isSelected ? theme.color.pink : 'transparent', borderRadius: '50%', border: isSelected ? '2px solid #fdf5f2' : 'transparent', overflow: 'hidden' }}
                    />
                  </CheckboxWrap>
                  <Flex flexDirection={'column'} ml={3} flex={1}>
                  <Text fontWeight={500} ml={3} fontSize={isMobile ? '14px' : ''}>
                      {x.label}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Option>
          );
        })}
      </Flex>

      <FootNote
        mb={4}
        alignItems={'flex-end'}
        style={{
          animationDelay: `${1 + 2 * OPTIONS_ANIMATION_DURATION}s`,
        }}
      >
        <Button mt={3} disabled={!state['assignedsexatbirth']} variant="primary" width={[1, 1 / 3]} type="submit" onClick={onContinue}>
          Continue
        </Button>
      </FootNote>
    </Flex>
  );
};
